export function clickEffect(event: MouseEvent, message: string) {
    const sentence = (event.target as HTMLElement).closest('.sentence')
    if (!sentence) return
    const partsAndTranslation = sentence.querySelector('.parts-and-translation')
    if (!partsAndTranslation) return

    // prevent that more than one message is rendered when clicked in short intervals
    const visibleMessage = sentence.querySelector('.click-effect')
    if (visibleMessage) {
        visibleMessage.closest('.parts-and-translation')?.removeChild(visibleMessage)
    }

    const d = document.createElement('div')
    d.className = 'click-effect'
    d.textContent = message

    partsAndTranslation.appendChild(d)

    const divRect = d.getBoundingClientRect()
    const divHeight = divRect.height
    d.style.top = 0 - divHeight + 10 + 'px'

    const divWidth = divRect.width
    const sentenceWidth = partsAndTranslation.getBoundingClientRect().width
    const clickOffset = event.offsetX

    const position = clickOffset - divWidth / 2
    const min = 0
    const max = sentenceWidth - divWidth

    d.style.left = checkRange(position, min, max) + 'px'
    d.addEventListener('animationend', () => d.parentElement?.removeChild(d))
}

function checkRange(value: number, min: number, max: number) {
    if (min <= value && value <= max) return value
    else if (value < min) return min
    else if (value > max) return max
}
